/* eslint-disable */

<template>
    <div>
        <BasicCard v-if="loading" v-bind:title="'Caricamento in corso'" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        <div v-else>
            <v-hover><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip></v-hover>
            <BasicCard class="pa-2">
                <template v-slot:title>
                    <span v-if="preview">dettagli</span>
                    <span v-else-if="category_new">nuovo set di prove</span>
                    <span v-else>modifica set di prove</span>
                </template>
                <template v-slot:action>
                    <v-btn v-if="!preview && !category_new" class="pa-2" text @click="restore"><v-icon>restore</v-icon>annulla modifiche</v-btn>
                </template>
                <v-form v-model="validityRegistry" ref="categoryRegistry" :readonly="preview">
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="5"> 
                            <v-text-field dense outlined
                                label="nome*"
                                v-model="c_category.name"
                                :rules="[rules.mandatory]"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                            <v-autocomplete dense outlined
                                class="pl-2"    
                                :items="Object.values(families).filter(f => { return f.enabled})"
                                item-text="label"
                                item-value="id"
                                v-model="c_category.family"
                                label="famiglia*"
                                :rules="[rules.mandatory]"
                                @change="findBlocks()">
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="3" v-if="c_category.family">
                                <v-autocomplete dense outlined
                                    class="pl-2"    
                                    :items="families[c_category.family].uoms"
                                    v-model="c_category.uom"
                                    item-value="id"
                                    label="unità di misura*"
                                    :rules="[rules.mandatory]">
                                    </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-if="c_category.family">
                            <v-expansion-panels class="d-flex">
                                <!--v-expansion-panel v-if="Object.keys(c_category.iso).length > 0">
                                    <v-expansion-panel-header color="expansion">
                                        <div class="d-flex align-start text-h6 text-uppercase font-weight-bold">Taratura ISO</div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="ma-0 pa-0">
                                        <div v-for="key in Object.keys(c_category.iso)" :key="key">
                                            <CategoryItem
                                            :category="c_category.iso[key]"
                                            op_type="iso"
                                            :dict_key="key"
                                            @updated="blockChanged"
                                            :preview="preview"
                                            />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel-->
                                <!--v-expansion-panel v-if="Object.keys(c_category.iso_simple).length > 0">
                                    <v-expansion-panel-header color="expansion">
                                        <div class="d-flex align-start text-h6 text-uppercase font-weight-bold">Taratura semplificata</div>
                                        <div class="d-flex align-start justify-center flex-grow-0 flex-shrink-1 mr-6">
                                            <v-checkbox class="mt-0" @click.stop.native  @change="changeIsoDefault" dense hide-details label="utilizza i valori della normativa" v-model="simple_default_values"></v-checkbox>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="ma-0 pa-0">
                                        <div v-for="key in Object.keys(c_category.iso_simple)" :key="key">
                                            <CategoryItem
                                            :category="c_category.iso_simple[key]"
                                            :key="c_category.iso_simple[key].calc_value"
                                            op_type="iso_simple"
                                            :dict_key="key"
                                            :uom="c_category.uom"
                                            @updated="blockChanged"
                                            :preview="preview"
                                            />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel-->
                                <v-expansion-panel v-if="Object.keys(c_category.leg).length > 0">
                                    <v-expansion-panel-header color="expansion">
                                        <div class="d-flex align-start text-h6 text-uppercase font-weight-bold">Verificazione periodica</div>
                                        <div class="d-flex align-start justify-center flex-grow-0 flex-shrink-1 mr-6">
                                            <v-checkbox class="mt-0" @click.stop.native  @change="changeLegDefault" dense hide-details label="utilizza i valori della normativa" v-model="vp_default_values"></v-checkbox>
                                        </div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content class="ma-0 pa-0">
                                        <div v-for="key in Object.keys(c_category.leg)" :key="key">
                                            <CategoryItem
                                            :category="c_category.leg[key]"
                                            :key="c_category.leg[key].calc_value"
                                            op_type="leg"
                                            :dict_key="key"
                                            :uom="c_category.uom"
                                            @updated="blockChanged"
                                            :preview="preview"
                                            />
                                        </div>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </v-container>
                </v-form>
                <div class="pa-4">
                    <v-alert
                        v-if="save_error"
                        dense
                        type="warning"
                        >
                        <div class="d-flex flex-column">
                            <div class="font-weight-bold">Salvataggio fallito</div>
                            <div>Riprovare oppure segnalare il problema all'amministratore di sistema.</div>
                        </div>
                    </v-alert>
                </div>
            </BasicCard>
            <div v-if="!preview" class="d-flex justify-center my-4">
                <v-btn color="primary" :disabled="!validityRegistry" @click="saveCategory()">Salva</v-btn>
                <v-btn class="ml-2" text @click="close">Annulla</v-btn>
            </div> 
        </div>
    </div>
</template>
<script>
// import _ from 'lodash'
import {getModel} from "../../utils/model"
import {f_rules} from "../../utils/commonUtils"
import {i_families} from "../../utils/common.js"
import BasicCard from '../../components/utils/Basic_card'
import CategoryItem from './CategoryItem'
export default {
    props: {
        'c_id': {
            type: String,
            required: true,
            default: null
        },
        'clone': {
            type: Boolean,
            required: false,
            default: false
        },
        'preview': {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        BasicCard, CategoryItem
    },
    data() {
        return {
            o_category: {},
            c_category: {},
            families: i_families,
            rules: f_rules,
            validityRegistry: true,
            category_new: true,
            loading: false,
            blocks: {
                iso: [],
                iso_simple: [],
                leg: []
            },
            simple_default_values: false,
            vp_default_values: false,
            save_error: false
        }
    },
    async mounted(){
        this.loading = true
        this.o_category = {}
        this.category_new = true
        if (this.c_id){
            let category = await this.$store.state.$pouch.get('masters', this.c_id)
            this.o_category = category
            this.c_category = _.cloneDeep(this.o_category)
            this.c_category.updated_by = this.$store.state.user._id
            this.category_new = false
            this.checkDefaultValues()
        } else {
            this.c_category = this.initObjectData({})
        }
        this.loading = false
        // this.$refs.categoryRegistry.resetValidation()
    },
    methods: {
        checkDefaultValues(){
            for(let key of Object.keys(this.c_category.iso_simple)){
                if(this.c_category.iso_simple[key].calc_value){
                    this.simple_default_values = true
                    break
                }
            }
            for(let key of Object.keys(this.c_category.leg)){
                if(this.c_category.leg[key].calc_value){
                    this.vp_default_values = true
                    break
                }
            }
        },
        initObjectData(data){
            data.created_by = this.$store.state.user._id
            let Category = getModel('Category')
            let category = Category(data)
            return category
        },
        restore() {
            this.c_category = _.cloneDeep(this.o_category);
        },
        close() {
            this.$router.push({path: '/admin/category/'})
        },
        async findBlocks(){
            // console.log("$$ finding blocks")
            let selector={
                doc_type: "baseblock",
                family: this.c_category.family,
                category: {"$nin": ["none"]}
            }
            let res = await this.$store.state.$pouch.find("masters", {selector:selector})
            console.log("$$ blocks found", res)
            if(res.docs.length > 0){
                this.blocks['iso'] = res.docs.filter(item => {
                    return item.op_types.includes('iso')  // filter to see if there is my op_type 
                });
                this.blocks['leg'] = res.docs.filter(item => {
                    return item.op_types.includes('leg')  // filter to see if there is my op_type 
                });
                this.blocks['iso_simple'] = res.docs.filter(item => {
                    return item.op_types.includes('iso_simple')  // filter to see if there is my op_type 
                });
                
                this.c_category.iso = {}
                for(let item of this.blocks['iso']){
                    this.c_category.iso[item._id] = this.buildCategory(item)
                }
                this.c_category.iso_simple = {}
                for(let item of this.blocks['iso_simple']){
                    this.c_category.iso_simple[item._id] = this.buildCategory(item)
                }
                this.c_category.leg = {}
                for(let item of this.blocks['leg']){
                    this.c_category.leg[item._id] = this.buildCategory(item)
                }
            }
        },
        buildCategory(item){
            if(item.category == "multiple"){
                let CategoryBlock = getModel('CategoryBlock')
                return CategoryBlock({label: item.label, name: item.name})
            } else {
                let SingleVal = getModel('CategoryBlockSingleVal')
                return SingleVal({label: item.label, name: item.name})
            }
        },
        blockChanged(item){
            this.c_category[item.op_type][item.key] = _.cloneDeep(item.values)
        },
        async saveCategory(){
            this.save_error = false
            this.c_category.updated = (new Date()).getTime()
            this.c_category.updated_by = this.$store.state.user._id
            try {
                let res = await this.$store.state.$pouch.put('masters', this.c_category)
                if (res.ok) {
                    this.c_category._rev = res.rev
                    // console.log("Update master " , res)
                    this.close()
                }
            } catch (error) {
                this.save_error = true
            }
        },
        changeIsoDefault(){
            for(let key of Object.keys(this.c_category.iso_simple)){
                this.c_category.iso_simple[key].calc_value = this.simple_default_values
            }
        },
        changeLegDefault(){
            for(let key of Object.keys(this.c_category.leg)){
                this.c_category.leg[key].calc_value = this.vp_default_values
            }
        }

    },
}
</script>